import { CanceledOrderRepository } from '../../domain/repositories/CanceledOrderRepository'
import { CanceledOrderFilterModel } from '../models/CanceledOrderFilterModel'
import { CanceledOrderResponseModel } from '../models/ItemResponseModel'
import type { CanceledOrderEntity } from '../../domain/entities/CanceledOrderEntity'
import type { CanceledOrderFilterEntity } from '../../domain/entities/CanceledOrderFilterEntity'
import type { CanceledOrderResponseEntity } from '../../domain/entities/CanceledOrderResponseEntity'
import { CanceledOrdersService } from '@/backend/market'
import { CanceledOrderModel } from '../models/CanceledOrderModel'

export class CanceledOrderRepositoryImpl implements CanceledOrderRepository {
  async getCanceledOrder(
    filterData: CanceledOrderFilterEntity
  ): Promise<CanceledOrderResponseEntity | { error: true }> {
    const itemsFilterModel = new CanceledOrderFilterModel(filterData)
    try {
      const response = await CanceledOrdersService.getCanceledOrdersAdmin(itemsFilterModel)
      const responseModel = new CanceledOrderResponseModel(response)
      return responseModel
    } catch {
      return { error: true }
    }
  }

  async getCancelOrderById(id: string): Promise<CanceledOrderEntity | { error: true }> {
    try {
      const response = await CanceledOrdersService.getCanceledOrderByIdAdmin({
        id: id
      })
      const itemModel = new CanceledOrderModel(response)
      return itemModel
    } catch {
      return { error: true }
    }
  }

  async getCanceledOrderByOrderId(id: string): Promise<CanceledOrderEntity | { error: true }> {
    try {
      const response = await CanceledOrdersService.getCanceledOrderByOrderAdmin({
        orderId: id
      })
      const itemModel = new CanceledOrderModel(response.canceledOrder)
      return itemModel
    } catch {
      return { error: true }
    }
  }
}
